import { useTranslation } from "react-i18next";
import { useApi } from "../contexts/ApiProvider";
import useDialog from "../contexts/DialogProvider";
import { useSnackbar } from "../contexts/SnackbarProvider";

const useUpdateData = () => {
  const showMessage = useSnackbar();
  const showDialog = useDialog();
  const api = useApi();
  const { t } = useTranslation();

  const updateHandler = async <T>(
    itemTitle: string,
    updateUrl: string,
    values: T
  ) => {
    const response = await api.put<T, null>(updateUrl, values);
    if (response.ok) {
      showMessage({
        text: t("Updated WHAT successfully", {
          what: itemTitle,
        }),
        severity: "success",
      });
    } else {
      showDialog({
        title: t("Updating WHAT failed", {
          what: itemTitle,
        }),
        text: t("Please, try again."),
      });
    }
  };

  return updateHandler;
};

export default useUpdateData;
